<template>
  <v-container>
    <v-row justify="center">
      <v-card class="unregistration ma-5 pa-5" max-width="600">
        <template v-if="hasRequest">
          <p>完了していない、または未払のお申込みがございます。</p>
          <p>お困りの場合は、
          <a href="https://sakusakurezept.com/contact/">お問い合わせ</a>
          をご利用ください。</p>
          <v-row class="mt-5">
            <v-col cols="12" class="d-flex justify-center">
              <v-btn text color="grey darken-2" @click="$router.push('/home')">戻る</v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-alert border="right" colored-border type="error" class="mb-5">
            登録を解除すると、作成済みのレセプトは削除されます。
          </v-alert>
          <v-divider />
          <v-row class="mt-5">
            <v-col cols="12" class="d-flex justify-center">
              <v-btn text color="grey darken-2" @click="$router.push('/home')">
                キャンセル
              </v-btn>
              <v-spacer />
              <v-btn color="red" dark @click="dialog = true">登録解除</v-btn>
            </v-col>
          </v-row>
        </template>
      </v-card>
    </v-row>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title>登録解除</v-card-title>
        <v-card-text>
          <p>登録解除は取り消しできません。</p>
          <p>登録を解除しますか？</p>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey darken-2" @click="dialog = false">
            キャンセル
          </v-btn>
          <v-btn color="red" text @click="unregistration">登録解除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

export default {
  name: 'Unregistration',
  data: () => ({
    dialog: false
  }),
  computed: {
    hasRequest() {
      let result = false;
      this.$store.state.requestItems.forEach((item) => {
        if (item.is_paid === 0) {
          result = true;
        }
        if (item.state !== '完了') {
          result = true;
        }
      });
      return result;
    }
  },
  mounted() {
    if (this.$store.state.loggedIn === false) {
      this.$store.commit('setAfterLoginPath', '/home');
      this.$router.push('/');
    } else {
      this.$store.dispatch('getRequestItems')
        .catch((err) => {
          if (err.response.status === 403) {
            this.$store.commit('setAfterLoginPath', '/home');
            alert('認証エラー：ログインページへ移動します。');
            this.$router.push('/');
          } else {
            alert('Server error.');
          }
        });
    }
  },
  methods: {
    unregistration() {
      this.$store.dispatch('unregistration').then(() => {
        this.$store.commit('setAfterLoginPath', '/home');
        this.$router.push('/');
      });
    }
  }
};
</script>
